import React from "react";
import moment from "moment";
import styled from "styled-components";
import { Table, Th, Tr, Td } from "./elements/Table";
import Check from "./icons/Check";
import Exclamation from "./icons/Exclamation";

const StatusIconWrapper = styled.span`
  padding-right: 5px;
`;

const GameIncidentUpdatesTable = props => {
  const { incident } = props;
  const { incidentDate } = incident;
  const rows = incident.incidentUpdates.map(incidentUpdate => {
    const { id, createdAt, status, severity, description } = incidentUpdate;
    return (
      <Tr key={id}>
        <Td>
          <StatusIconWrapper>
            {status === "Open" ? (
              <Exclamation shape="circle" />
            ) : (
              <Check shape="circle" />
            )}
          </StatusIconWrapper>
        </Td>
        <Td>{incidentDate}</Td>
        <Td>
          {moment(createdAt)
            .utcOffset("-0400")
            .format("LT")}
        </Td>
        <Td>{status}</Td>
        <Td>{severity}</Td>
        <Td>
          <div style={{ whiteSpace: "pre-wrap" }}>{description}</div>
        </Td>
      </Tr>
    );
  });

  return (
    <Table width="100%">
      <colgroup>
        <col width="2%" />
        <col width="10%" />
        <col width="10%" />
        <col width="10%" />
        <col width="10%" />
      </colgroup>
      <thead>
        <Tr>
          <Th />
          <Th>Date</Th>
          <Th>Updated At</Th>
          <Th>Status</Th>
          <Th>Severity</Th>
          <Th textAlignment="left">Latest Update</Th>
        </Tr>
      </thead>
      <tbody>{rows}</tbody>
    </Table>
  );
};

export default GameIncidentUpdatesTable;



// WEBPACK FOOTER //
// ./src/components/GameIncidentUpdatesTable.js